import { Loader2 } from 'lucide-react'
import EventAvatar from 'app/frontend/base/components/EventAvatar'
import { Skeleton } from '@/components/ui/skeleton'

type Props = {
  eventReference?: wowaudit.EventReference
}

const TeamEventSkeleton = ({ eventReference }: Props) => {
  return (
    <div>
      <div className='mb-4 flex items-start justify-between gap-4 flex-wrap'>
        <div className='flex items-center gap-3 min-w-0'>
          {eventReference ? (
            <EventAvatar
              eventReference={eventReference}
              variant='square'
              className='w-14 h-14 border border-border shrink-0'
            />
          ) : (
            <Skeleton className='w-14 h-14 shrink-0 border-0' />
          )}
          <div className='min-w-0'>
            <h2 className='truncate m-0 mr-2'>
              <Skeleton className='inline-block h-[1em] w-56 align-middle border-0 opacity-40' />
            </h2>
            <div className='mt-2 h-7 flex items-center'>
              <Skeleton className='h-4 w-64 border-0 opacity-40' />
            </div>
          </div>
        </div>
      </div>

      <div className='flex justify-center pt-24'>
        <Loader2 className='h-16 w-16 animate-spin text-muted-foreground fade-in duration-1500' />
      </div>
    </div>
  )
}

export default TeamEventSkeleton
